var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42668 14C10.9356 14 12.2306 13.51 13.3117 12.53C14.3928 11.55 14.9333 10.3289 14.9333 8.86667C14.9333 7.40444 14.3928 6.18333 13.3117 5.20333C12.2306 4.22333 10.9356 3.73333 9.42668 3.73333H3.54668L5.97335 1.30667L4.66668 0L1.62125e-05 4.66667L4.66668 9.33333L5.97335 8.02667L3.54668 5.6H9.42668C10.4067 5.6 11.2583 5.91111 11.9817 6.53333C12.705 7.15556 13.0667 7.93333 13.0667 8.86667C13.0667 9.8 12.705 10.5778 11.9817 11.2C11.2583 11.8222 10.4067 12.1333 9.42668 12.1333H2.80002V14H9.42668Z",
    fill: "url(#paint0_linear_2531_4170)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2531_4170",
    x1: 7.46668,
    y1: 0,
    x2: 7.46668,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.6a480c5c0f9b3f8250f85fd3e9f09aca.svg";
export { ForwardRef as ReactComponent };